import { useEffect, useState } from "react";

function SvgIcon({ src, className }) {
  const [svg, setSvg] = useState(null);

  useEffect(() => {
    fetch(src)
      .then((res) => res.text())
      .then((txt) => setSvg(txt));
  }, [src]);

  return svg ? (
    <span
      className={className}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  ) : null;
}

export default SvgIcon;
